module.exports = __webpack_public_path__ + "img/img_charge_phone_img4.34bb8ece.png";